<template>
  <div :class="[jel_getClassObject(content), content.theme]">
    <b-img-lazy
      v-if="content.image"
      :src="jel_getFichierSrc(content.image)"
      :alt="content.texte"
      class="taille-image mr-1"
    />

    <div
      v-if="content.texteSecondaire && content.type != 'lienMAJ'"
      class="d-inline-flex"
      v-html="modifierMessage(content.texteSecondaire)"
    />

    <!-- Les TYPES sont triés du plus courant au moins courant -->
    <!-- ***** TYPE: Liens Interne ou Externe ***** -->
    <template
      v-if="
        content.lien &&
        content.lien.field &&
        (content.lien.field.startsWith('lienInterne') || content.lien.field == 'lienExterne')
      "
    >
      <!-- Styles boutons -->
      <b-button
        v-if="isButton"
        v-bind="lienInterne()"
        :variant="boutonVariant"
        :rel="content.lien.lienInterneAsset ? 'noopener noreferrer' : ''"
        :target="targetLien"
        data-lien="liens"
        class="btn w-xs-auto w-md-auto hauteur px-4"
        :class="content.type"
        :disabled="disabled"
      >
        <span class="lien-interne-externe" v-html="texteBouton" />
        <svg-icon v-if="content.lien.nomIcone" :icon-name="content.lien.nomIcone" class="ml-4px" />
      </b-button>
      <!-- Autres styles -->
      <div v-else :class="classeCSSLien">
        <span @click.capture="gaPreventClick">
          <b-link
            v-bind="lienInterne()"
            class="text-decoration-none"
            :class="[{ 'ml-4px': content.texteSecondaire }]"
            :rel="content.lien.lienInterneAsset ? 'noopener noreferrer' : ''"
            :target="targetLien"
            :disabled="disabled"
          >
            <div :class="classeCSSLien">
              <div :class="content.type" v-html="content.texte" />
              <svg-icon
                v-if="content.lien.nomIcone"
                :icon-name="content.lien.nomIcone"
                class="taille-icone"
                :class="[
                  content.lien.cssIcone,
                  content.lien.positionImage === 'gauche' ? 'mr-1' : 'ml-1',
                ]"
              />
              <!-- TODO: Traiter l'affichage complet de lienMAJ -->
              <span
                v-if="content.type == 'lienMAJ' && content.texteSecondaire"
                class="d-inline-block lien-interne-externe"
                v-html="modifierMessage(content.texteSecondaire)"
              />
            </div>
          </b-link>
        </span>
      </div>
    </template>
    <!-- ***** TYPE: Hyperlien Précédent ***** -->
    <!-- Obsolète: utiliser le composant lienRetour à la place, soit pour le comportement ou le style d'affichage -->
    <template v-else-if="content.lien && content.lien.field == 'precedent'">
      <!-- Styles boutons -->
      <b-button
        v-if="isButton"
        :variant="boutonVariant"
        data-precedent="precedent"
        class="btn w-xs-auto w-md-auto hauteur px-4"
        :class="content.type"
        @click="jel_traiterRetour()"
        v-html="content.texte"
      />

      <!-- Autres styles -->
      <b-link v-else :class="content.type" @click="jel_traiterRetour()">
        <svg-icon class="mr-1" scale="0.7" icon-name="fleche-lien-gauche"></svg-icon>
        <div v-html="content.texte" />
      </b-link>
    </template>

    <!-- ***** TYPE: Hyperlien Aide ***** -->
    <template v-else-if="(content.lien && content.lien.field == 'aide') || content.type == 'aide'">
      <!-- Styles boutons -->
      <b-button
        v-if="isButton"
        :variant="boutonVariant"
        data-aide="aide"
        class="btn w-xs-auto w-md-auto hauteur px-4"
        :class="content.type"
        @click="toggleAide"
        v-html="content.texte"
      />

      <!-- Autres styles -->
      <b-link v-else :class="content.type" class="d-inline-flex" @click="toggleAide">
        <div v-html="content.texte" />
        <!-- TODO: Traiter l'affichage complet de lienMAJ -->
        <div v-if="content.type == 'lienMAJ'" v-html="content.texteSecondaire"></div>
        <!-- TODO: Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
      </b-link>
    </template>

    <!-- ***** TYPE: Hyperlien Zone Escamotable ***** -->
    <template v-else-if="content.lien?.field?.includes('escamotable')">
      <!-- Styles boutons -->
      <b-button
        v-if="isButton"
        :variant="boutonVariant"
        data-aide="aide"
        class="btn w-xs-auto w-md-auto hauteur px-4"
        :class="content.type"
        @click="lienEscamotable"
        v-html="content.texte"
      />

      <!-- Autres styles -->
      <b-link v-else :class="content.type" class="d-inline-flex" @click="lienEscamotable">
        <div v-html="content.texte" />
        <!-- TODO: Traiter l'affichage complet de lienMAJ -->
        <div v-if="content.type == 'lienMAJ'" v-html="content.texteSecondaire"></div>
        <!-- TODO: Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
      </b-link>
    </template>

    <!-- ***** TYPE: Lien Product Source ***** -->
    <template v-if="content.lien && content.lien.field == 'lienRetourProductSource'">
      <span v-if="['lienPrimaire', 'lienSecondaire', 'lienTertiaire'].includes(content.type)">
        <b-link
          v-if="urlProductSource || mixinEnvironnement_inEditor"
          v-bind="lienProductSource()"
          :class="content.type"
          v-html="content.texte"
        />
      </span>
      <span v-if="['boutonPrimaire', 'boutonSecondaire', 'boutonTertiaire'].includes(content.type)">
        <b-button
          v-if="urlProductSource || mixinEnvironnement_inEditor"
          :variant="boutonVariant"
          v-bind="lienProductSource()"
          :data-product-source="content.texte"
          :class="content.type"
          class="btn w-xs-auto w-md-auto hauteur px-4 btn-product-source"
          v-html="content.texte"
        >
        </b-button>
      </span>
    </template>

    <!-- ***** TYPE: Lien modale ***** -->
    <template v-else-if="content.lien && content.lien.field == 'modale'">
      <span>
        <!-- Styles boutons -->
        <b-button
          v-if="isButton"
          v-b-modal="modaleUUID"
          :variant="boutonVariant"
          :data-modale="content.texte"
          class="w-100 w-md-auto hauteur"
          :class="{
            'p-0 d-flex flex-row justify-content-between align-items-center':
              content.type == 'boutonTertiaire',
          }"
          ><div v-html="content.texte" />
          <svg-icon
            v-if="content.type == 'boutonTertiaire'"
            class="icone-fleche rotation270 ml-2"
            icon-name="fleche-bas"
          />
        </b-button>

        <!-- Autres styles -->
        <b-link v-else v-b-modal="modaleUUID" :class="content.type">
          <span v-html="content.texte" />
        </b-link>
      </span>

      <!-- Fenêtre modale -->
      <b-modal
        :id="modaleUUID"
        :hide-footer="true"
        dialog-class="modal-dialog-aide pt-0 px-2 px-md-0 h-100"
        content-class="modal-content-aide compteClair pl-2 pl-sm-2 pl-lg-5 pb-2"
        body-class="pr-2 pr-lg-5 pr-md-2 pb-sm-7 ml-0"
        header-class="compteClair pl-2 pr-0 pb-1 w-100"
      >
        <template #modal-header="{ hide }">
          <div class="d-flex mt-1">
            <div class="col-10 px-0">
              <h2 class="text-left w-100">{{ content.lien.titreModale }}</h2>
            </div>
            <div class="col-2 px-0">
              <button class="btnVide" @click="hide()">
                <svg-icon
                  icon-name="icone-fermer-mince"
                  color="$couleur-primaire"
                  className="iconeFermer"
                />
              </button>
            </div>
          </div>
        </template>

        <div v-html="content.lien.texteModale"></div>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { bus } from '@/main';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import { obtenirSiteIds } from '@/services/api/compte/sites';

import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

export default {
  name: 'Hyperlien',
  mixins: [mixinEnvironnement],
  props: {
    content: { type: Object, required: true },
    disabled: { type: Boolean, required: false },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          ko: 'ko',
        },
      },
      en: {
        messageComponent: {
          ko: 'KB',
        },
      },
    },
  },
  data() {
    return {
      urlProductSource: null,
      idAide: null,
    };
  },
  computed: {
    ...mapState(['aide']),
    isButton() {
      return this.content.type.toLowerCase().includes('bouton');
    },
    boutonVariant() {
      return this.content.type.split('bouton')[1].toLowerCase();
    },
    modaleUUID() {
      return this.uid;
    },
    texteBouton() {
      if (
        this.content.lien.field === 'lienInterneAsset' &&
        this.content.lien.cacherPoidsFichier !== 'true'
      ) {
        return `${this.content.texte} (${(
          Math.round((this.content.lien.lienInterneAsset.metadata.fileSize / 1024) * 10) / 10
        ).toLocaleString()} ${this.$t('messageComponent.ko')})`;
      }
      return this.content.texte;
    },
    isPageCasino() {
      return window.location.pathname.includes('casino');
    },
    getUrlProductSource() {
      return this.urlProductSource;
    },
    classeCSSLien() {
      const baseClasse = this.content.type !== 'lienMAJ' ? 'd-inline-flex' : 'd-flex';
      const positionClasse =
        this.content.lien.positionImage === 'gauche' ? 'flex-row-reverse' : 'flex-row';
      const customClasse = this.content.classeCSSLien ? ` ${this.content.classeCSSLien}` : '';

      return `${baseClasse} ${positionClasse}${customClasse}`;
    },
    targetLien() {
      const { lienInterneAsset, field, isTargetBlank } = this.content.lien;
      return lienInterneAsset ||
        (['lienExterne', 'lienInterne'].includes(field) && isTargetBlank === 'true')
        ? '_blank'
        : '_self';
    },
  },
  async created() {
    if (this.content.lien && this.content.lien.field == 'lienRetourProductSource') {
      obtenirSiteIds()
        .then((response) => {
          if (!response) {
            return;
          }
          const siteIds = response.data;
          if (
            siteIds &&
            this.content.lien.typeProductSource &&
            siteIds[this.content.lien.typeProductSource]
          ) {
            this.urlProductSource = siteIds[this.content.lien.typeProductSource];
          }
        })
        .catch((error) => {
          console.log("Erreur à l'initialisation des Site IDs", error);
        });
    }
  },
  async mounted() {
    if (this.content.lien?.idEscamotable) {
      this.$store.dispatch('aide/initRubriqueAide', {
        idRubriqueAide: [this.content.lien.idEscamotable],
      });
      await this.$store.dispatch('aide/toggleAide').then(() => {
        this.idAide = this.aide.listeQuestionsReponses[0].name;
      });
    }
  },
  methods: {
    gaPreventClick() {
      const event = 'ga-pp-click';
      const categorie = 'PP - Pied de page';
      const libelle = `Lien ${this.texteBouton}`;
      const emplacement = this.jel_gaGetEmplacement();
      if (
        ['lienTertiaire'].includes(this.content.type) &&
        this.content.lien &&
        this.content.lien.field == 'lienExterne'
      ) {
        // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event,
          categorie,
          emplacement: `${this.jel_gaGetEmplacement()}`,
          libelle,
        });
      }
    },
    lienInterne() {
      if (this.content.lien.field === 'lienInterneAsset') {
        return {
          href: this.jel_getFichierSrc(this.content.lien.lienInterneAsset),
        };
      }
      return this.jel_getLienBinding(this.content.lien);
    },
    lienProductSource() {
      const params = this.content.lien.urlParams
        ? (this.getUrlProductSource.indexOf('?') == -1 ? '?' : '&') + this.content.lien.urlParams
        : '';
      return {
        href: this.getUrlProductSource + params,
      };
    },
    // Nécessaire pour régler un problème d'accessibilité:
    // Block-level element ne peut être dans un inline-level element
    modifierMessage(message) {
      if (message.includes('<p>')) {
        message = message.replace('<p>', '<span>');
        message = message.replace('</p>', '</span>');
      }
      return message;
    },
    toggleAide() {
      this.$store.dispatch('aide/toggleAide', this.content.lien.idAide);
    },
    async lienEscamotable() {
      bus.$emit(
        'ouvrirZoneEscamotable',
        this.content.lien.field == 'escamotableSection' ? this.content.lien.idSection : this.idAide
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.taille-image {
  height: 1.25rem;
  width: 1.25rem;
  padding-bottom: 0.2rem;
}

.taille-icone {
  height: 1.25rem;
  width: 1.25rem;
}

.aide {
  color: currentColor;
  font-weight: bold;
  font-size: 0.75rem;
}
div ::v-deep p {
  display: block;
}

.btn.btn-tertiaire {
  height: fit-content;
  text-align: left;
}
.icone-fleche {
  flex-shrink: 0;
}
.aide {
  text-decoration: underline;
  line-height: 1rem;
}
.aide:hover {
  text-decoration: none;
}
.hauteur {
  padding: 0.65rem 1.5rem;

  @include media-breakpoint-down(md) {
    padding: 0.75rem 0.9rem;
  }
}
.titreLienCategories {
  @media screen and (max-width: 575px) {
    a {
      svg {
        margin-left: auto !important;
      }
    }
  }
  font-size: $font-size-6;
  line-height: $line-height-6;
  padding-top: 14px;
  padding-bottom: 4px;
  a {
    color: $couleur-bleu-fonce-lq;
    width: fit-content;
    text-decoration: none;
    svg {
      color: $couleur-bleu-fonce-lq;
      object-fit: contain;
    }
  }
}
.lien-interne-externe {
  color: unset;
}

.btn.btn-primaire.btn-product-source {
  color: $couleur-secondaire;
}
.disabled .lienSecondaire {
  border: none;
  color: $couleur-bg-spinner-full-screen;
}

.canafe {
  svg {
    display: none;
  }
}

.lienAideOverride {
  .lienPrimaire {
    font-family: graphik_regular !important;
    font-size: 16px;
    font-weight: 700;
    padding: 0;
  }
  .taille-image {
    padding-bottom: 0;
    width: 30px;
    height: 30px;
  }
}

.lien-offre {
  color: $couleur-blanc !important;
  text-decoration: underline !important;
  font-family: graphik_regular;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0px;
  padding: 0 16px;
  opacity: 1;
}

.lien-offre:hover {
  color: $couleur-secondaire !important;
}

.rem-style {
  .lienTertiaire:active {
    border: none !important;
    color: #192872 !important;
  }
}
</style>
